<template>
    <center>
        <div class="not_found">
            <v-container>
                <v-row>
                    <v-col lg="6" sm="12" class="self-center">
                        <div class="img">
                            <img src="@/assets/images/page_not_found.svg" alt="">
                        </div>
                    </v-col>
                    <v-col lg="6" sm="12" class="self-center">
                        <div class="contents">
                            <span>Ooups,</span>
                            <h3>There's nothing here!</h3>
                            <p>
                                Not all who wander are lost. But you certainly are
                            </p>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </center>
    
</template>

<script>

  export default {
    name: 'NotFound'
  }

</script>

<style scoped>
center {
    margin: 4vw 6vw;
    height: 100%;
    place-self: center;
}
.not_found{
    margin-top: 85px;
}
.self-center{
    place-self: center;
}
.contents{
    text-align: left;
    padding: 0 50px;
}
span{
    font-size: 70px;
    font-weight: 800;
    color: #e91e24;
}
h3{
    font-size: 23px;
}
img{
    max-width: 70%
}
</style>